import * as T from './loyaltyMembersTypes';
import type { PaginationState } from './loyaltyMembersTypes';
import type { Member, PointActivity, RewardRedemption } from '../../../components/loyalty/data/types';
import type { ListMembersParams, ExportPayload } from '../../../services/loyaltyMembersApi';

export const fetchMembersRequest = (params?: ListMembersParams) => ({
  type: T.FETCH_MEMBERS_REQUEST as typeof T.FETCH_MEMBERS_REQUEST,
  payload: params,
});
export const fetchMembersSuccess = (members: Member[], pagination: PaginationState) => ({
  type: T.FETCH_MEMBERS_SUCCESS as typeof T.FETCH_MEMBERS_SUCCESS,
  payload: { members, pagination },
});
export const fetchMembersFailure = (error: string) => ({
  type: T.FETCH_MEMBERS_FAILURE as typeof T.FETCH_MEMBERS_FAILURE,
  payload: error,
});

export const fetchMemberProfileRequest = (loyaltyCustomerId: string) => ({
  type: T.FETCH_MEMBER_PROFILE_REQUEST as typeof T.FETCH_MEMBER_PROFILE_REQUEST,
  payload: loyaltyCustomerId,
});
export const fetchMemberProfileSuccess = (member: Member) => ({
  type: T.FETCH_MEMBER_PROFILE_SUCCESS as typeof T.FETCH_MEMBER_PROFILE_SUCCESS,
  payload: member,
});
export const fetchMemberProfileFailure = (error: string) => ({
  type: T.FETCH_MEMBER_PROFILE_FAILURE as typeof T.FETCH_MEMBER_PROFILE_FAILURE,
  payload: error,
});

export const fetchMemberTransactionsSuccess = (
  activities: PointActivity[],
  redemptions: RewardRedemption[],
) => ({
  type: T.FETCH_MEMBER_TRANSACTIONS_SUCCESS as typeof T.FETCH_MEMBER_TRANSACTIONS_SUCCESS,
  payload: { activities, redemptions },
});

export const adjustPointsRequest = (
  loyaltyCustomerId: string,
  points: number,
  reason: string,
) => ({
  type: T.ADJUST_POINTS_REQUEST as typeof T.ADJUST_POINTS_REQUEST,
  payload: { loyaltyCustomerId, points, reason },
});
export const adjustPointsSuccess = (loyaltyCustomerId: string, newBalance: number, points: number) => ({
  type: T.ADJUST_POINTS_SUCCESS as typeof T.ADJUST_POINTS_SUCCESS,
  payload: { loyaltyCustomerId, newBalance, points },
});
export const adjustPointsFailure = (error: string) => ({
  type: T.ADJUST_POINTS_FAILURE as typeof T.ADJUST_POINTS_FAILURE,
  payload: error,
});

export const exportMembersRequest = (payload: ExportPayload) => ({
  type: T.EXPORT_MEMBERS_REQUEST as typeof T.EXPORT_MEMBERS_REQUEST,
  payload,
});
export const exportMembersSuccess = (exportId: string, status: string) => ({
  type: T.EXPORT_MEMBERS_SUCCESS as typeof T.EXPORT_MEMBERS_SUCCESS,
  payload: { exportId, status },
});
export const exportMembersFailure = (error: string) => ({
  type: T.EXPORT_MEMBERS_FAILURE as typeof T.EXPORT_MEMBERS_FAILURE,
  payload: error,
});

export const toggleNotificationRequest = (memberId: string, enabled: boolean) => ({
  type: T.TOGGLE_NOTIFICATION_REQUEST as typeof T.TOGGLE_NOTIFICATION_REQUEST,
  payload: { memberId, enabled },
});
export const toggleNotificationSuccess = (memberId: string) => ({
  type: T.TOGGLE_NOTIFICATION_SUCCESS as typeof T.TOGGLE_NOTIFICATION_SUCCESS,
  payload: memberId,
});
export const toggleNotificationFailure = (error: string) => ({
  type: T.TOGGLE_NOTIFICATION_FAILURE as typeof T.TOGGLE_NOTIFICATION_FAILURE,
  payload: error,
});
export const toggleNotificationRevert = (memberId: string, enabled: boolean) => ({
  type: T.TOGGLE_NOTIFICATION_REVERT as typeof T.TOGGLE_NOTIFICATION_REVERT,
  payload: { memberId, enabled },
});

export type LoyaltyMembersAction =
  | ReturnType<typeof fetchMembersRequest>
  | ReturnType<typeof fetchMembersSuccess>
  | ReturnType<typeof fetchMembersFailure>
  | ReturnType<typeof fetchMemberProfileRequest>
  | ReturnType<typeof fetchMemberProfileSuccess>
  | ReturnType<typeof fetchMemberProfileFailure>
  | ReturnType<typeof fetchMemberTransactionsSuccess>
  | ReturnType<typeof adjustPointsRequest>
  | ReturnType<typeof adjustPointsSuccess>
  | ReturnType<typeof adjustPointsFailure>
  | ReturnType<typeof exportMembersRequest>
  | ReturnType<typeof exportMembersSuccess>
  | ReturnType<typeof exportMembersFailure>
  | ReturnType<typeof toggleNotificationRequest>
  | ReturnType<typeof toggleNotificationSuccess>
  | ReturnType<typeof toggleNotificationFailure>
  | ReturnType<typeof toggleNotificationRevert>;
